/* global __CLIENT__ */
// from https://github.com/arturfsousa/react-playbuzz
// modified to reduce dependencies and to adapt for our use case (passing in data-id from embeded script)

import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';

const PlayBuzz = ({ id }) => {
    const [isMounted, setIsMounted] = useState(false);

    useEffect(() => {
        setIsMounted(true);
        if (id && __CLIENT__ && !window.PlayBuzz) {
            const script = document.createElement('script');

            script.src = '//embed.playbuzz.com/sdk.js';

            script.async = true;

            document.body.appendChild(script);
        }
    }, [id]);

    // Server renders null. Match that before mount to avoid a #418 hydration mismatch.
    if (!isMounted || !id) {
        return null;
    }

    return (
        <div
            className="playbuzz"
            data-id={id}
            data-show-info="false"
            data-recommend="false"
            data-comments="false"
            data-show-share="false"
        />
    );
};

PlayBuzz.propTypes = exact({
    id: PropTypes.string.isRequired,
});

export default PlayBuzz;
